import React from 'react'

import { Flex } from 'ui/acro'

import { BonusItem } from './BonusItem'
import { ClassCard } from '../common/components'
import { Badge } from './badge'
import { useUserContext } from 'context'

export const ItemCards = (cardDetails) => {
  const { user } = useUserContext() || {}
  return (
    <Flex
      flexDirection='column'
      className={`swiper-slide card-item unstyled ${
        cardDetails?.itemTag ? '' : 'no-tag'
      }`}
    >
      {(() => {
        if (cardDetails.itemType === 'class') {
          return (
            <>
              {cardDetails?.itemTag && <Badge>{cardDetails?.itemTag}</Badge>}
              <ClassCard
                {...cardDetails.item}
                membershipTier={user?.membershipTier}
                onPlaylistIconClick={cardDetails.onPlaylistIconClick}
                showScheduleButton={cardDetails.showScheduleButton}
                handleAddToCalendarClick={cardDetails.handleAddToCalendarClick}
                isFevIcon={Boolean(user)}
              />
            </>
          )
        } else if (cardDetails.itemType === 'bonus') {
          return <BonusItem {...cardDetails} />
        }
        return <></>
      })()}
    </Flex>
  )
}
